import React, { useState } from "react";
import LoadingComponent from "@Components/LoadingComponent/LoadingComponent";
import themeCreator from "@Themes/themeCreator";
import PageTitle from "@Components/PageTitle/PageTitle";
import { Container } from "@mui/material";
import DateSelector from "@Components/DateTimePickers/DatePicker";
import useSendPostRequest from "@Hooks/useSendPostRequest";
import { CARGOX_URL } from "../../API/APIRoutes";
import DropDown from "../../Components/DropDown/DropDown";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import {
  OptionalDropDownValidation,
  pastOrNowDateValidation,
} from "@Utils/Validations/UserValidations/UserValidationFieldsSchema";
import { Grid, Typography, TextField, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import { FormStyle } from "../Styles/FormStyle";
import { useParams } from "react-router-dom";
import Joi from "joi";
import { validateForm } from "@Utils/Validations/HelperFunctions/FormValidationFunctions";
import { formatDateUTC } from "../../Utils/Validations/HelperFunctions/FormaterFunctions";
import { decryptId, encryptId } from "../../Utils/SecurityFunctions";
export default function AddCargoX() {
  const orderId = decryptId(useParams().orderId);
  const theme = themeCreator();
  const navigate = useNavigate();

  const cargoxNames = [
    { id: "Select CargoX Name", name: "Select CargoX Name" },
    { id: "BOL", name: "BOL" },
    { id: "PACKING_LIST", name: "PACKING LIST" },
    { id: "INVOICE", name: "INVOICE" },
    { id: "ELECTRONIC_INVOICE", name: "ELECTRONIC INVOICE" },
    { id: "COO", name: "COO" },
    { id: "COA", name: "COA" },
    { id: "EURO1", name: "EURO1" },
  ];
  const cargoxStatuses = [
    { id: "Select CargoX Status", name: "Select CargoX Status" },
    { id: "NOT_UPLOADED", name: "Not Uploaded" },
    { id: "PARTIALLY_UPLOADED", name: "Partially Uploaded" },
    { id: "UPLOADED", name: "Uploaded" },
  ];

  const initialCargoX = {
    cargoXName: "Select CargoX Name",
    cargoXStatus: "Select CargoX Status",
    cargoXUploadDate: null,
    comment: "",
  };
  const validationSchema = Joi.object({
    cargoXUploadDate: Joi.alternatives()
      .try(pastOrNowDateValidation, Joi.allow(null))
      .optional(),
    cargoXName: OptionalDropDownValidation("CargoX Name"),
    cargoXStatus: OptionalDropDownValidation("CargoX Status"),
    comment: Joi.string().allow(""),
    orderId: Joi.string().required(),
  });
  const [cargox, SetCargoX] = useState(initialCargoX);
  const [errors, setErrors] = useState({
    cargoXName: "",
    cargoXStatus: "",
    cargoXUploadDate: "",
    comment: "",
  });
  const { isLoading: isloading, requestMethod: postData } =
    useSendPostRequest(true);

  const onDatePick = (newValue) => {
    SetCargoX({ ...cargox, cargoXUploadDate: newValue });
    setErrors({ ...errors, cargoXUploadDate: "" });
  };

  const clearData = () => {
    SetCargoX(initialCargoX);
    setErrors({
      cargoXName: "",
      cargoXStatus: "",
      cargoXUploadDate: "",
      comment: "",
    });
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault(); // Add this to prevent form submission

    // Format all dates in the invoice and payments
    const formattedCargox = {
      ...cargox,
      cargoXUploadDate: formatDateUTC(cargox.cargoXUploadDate),
      orderId: orderId,
    };

    if (validateForm(formattedCargox, setErrors, validationSchema)) {
      const response = await postData(
        CARGOX_URL,
        formattedCargox,
        null,
        "Cargox has been added successfully."
      );
      if (response) {
        sessionStorage.setItem("openSectionIndex", 0);
        navigate(DefaultRoutes.orderInfo.replace(":orderId", encryptId(orderId)));
      }
      clearData();
    }
  };

  const form = (
    <>
      <form onSubmit={handleOnSubmit} className="formWrapper">
        <Grid
          className="inputContainer"
          container
          spacing={2}
          justifyContent="flex-end"
        >
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              CargoX Name
            </Typography>
            <DropDown
              state={cargox.cargoXName}
              setState={(value) => {
                SetCargoX({ ...cargox, cargoXName: value });
                setErrors({ ...errors, cargoXName: "" });
              }}
              name="cargoX Name"
              label=""
              items={cargoxNames}
              placeholder="Select CargoX Name"
              helperText={errors.cargoXName}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              CargoX Status
            </Typography>
            <DropDown
              state={cargox.cargoXStatus}
              setState={(value) => {
                SetCargoX({ ...cargox, cargoXStatus: value });
                setErrors({ ...errors, cargoXStatus: "" });
              }}
              name="cargoX Status"
              label=""
              items={cargoxStatuses}
              placeholder="Select CargoX Status"
              helperText={errors.cargoXStatus}
            />
          </Grid>
          <Grid item xs={12}>
            <DateSelector
              name={"CargoX Upload Date"}
              value={cargox.cargoXUploadDate}
              error={errors.cargoXUploadDate}
              onPick={onDatePick}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Comment (Optional)
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              name="comment"
              type="text"
              placeholder="Comment"
              value={cargox.comment}
              onChange={(e) =>
                SetCargoX({ ...cargox, comment: e.target.value })
              }
            />
          </Grid>
          <Box
            className="submissionBox"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mt: 2,
              }}
            >
              <Button
                type="submit"
                variant="contained"
                className="submissionButton"
                size="large"
                disabled={isloading}
              >
                {!isloading ? (
                  "Add CargoX"
                ) : (
                  <LoadingComponent size="2em" thickness={5} color="white" />
                )}
              </Button>
            </Box>
          </Box>
        </Grid>
      </form>
    </>
  );
  return (
    <FormStyle className="PageContainer">
      <Container
        sx={{ pb: 5, pr: "0px !important", pl: "0px !important" }}
        disableGutters
      >
        <Box className="LabelButtonBox">
          <PageTitle
            title={"New CargoX"}
            PageIcon={<LocalShippingIcon color="white" fontSize="large" />}
            iconColor={theme.palette.primary.main}
          ></PageTitle>
        </Box>
        <Box sx={{ pt: 3 }}>{form}</Box>
      </Container>
    </FormStyle>
  );
}
